export default __webpack_public_path__ + "static/media/double-both-border-right.ea6a9363.svg";